import React from "react";

import "./Loader.css";
import LoaderBG from "../../Ressources/Images/loader.png";
import LogoSvg from "../LogoSvg/LogoSvg";

const Loader: React.FC = () => {
  return (
    <div className="loader" style={{ backgroundImage: `url(${LoaderBG})` }}>
      <div className="logoContainer">
        <LogoSvg />
      </div>
      <div className="spinner"></div>
      <p>Chargement...</p>
      <div className="bottomCopyright">
        © 2024 - Joon, sous la marque Joonsoft - tous droits réservés
      </div>
    </div>
  );
};

export default Loader;
